/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).ready(function(){
  $(document).on('change', '.ProductItem #product-select', function(){
    var vk_variantSelect = $(this).find(":selected").val();
    console.log(vk_variantSelect);
    // $(this).parent().find('input[name="id"]').attr('value', vk_variantSelect);
    $(this).parent().find('input[name="id"]').val(vk_variantSelect);
  });


  $(document).on('click', '.ProductItem .vk--cart-form .vk--add_to_cart', function(e){
    e.preventDefault()
     var value = $(this).parents('.vk--cart-form').find('input[name="id"]').val();
      
    console.log(value);

      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:    
           items = {
          "id": value,
          "quantity": 1
        }, 
          dataType: 'json',
          success: function(data) {
              // console.log(data)
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
            // jQuery('.vk--cart-icon').trigger('click');
            var classes = document.getElementsByClassName('vk--cart-icon');
              var Rate = classes[0];
              Rate.click();
            return false;
          }
     });
    });


  // $(document).on('click', '.ProductForm__Variants .ColorSwatchList input.ColorSwatch__Radio', function(){
  //   // console.log($(this).attr('id'));
  //   var variantMediaId = $(this).parents('.ProductForm__Variants').find('.no-js select').find('option[selected="selected"]').attr('variant-media-id');
  //   console.log(variantMediaId);
  //   $('.Product__Gallery .Product__SlideshowNav--thumbnails .Product__SlideshowNavImage').each(function(){
  //     var thumbnailMedia = $(this).attr('data-media-id');
  //     console.log(thumbnailMedia);
  //     if(variantMediaId == thumbnailMedia){
  //       $(this).show();
  //     }else{
  //       $(this).hide();
  //     }
  //   });
  // });

  
  
  $(document).on('mouseover', '.MegaMenu__Inner li.Linklist__Item', function(){
    var imageUrl = $(this).attr('menu_image');
    // console.log(imageUrl)
    $(this).parents('.MegaMenu__Inner').find('.MegaMenu__Item.vk--image-wrapper .vk--menu-image').attr('src', imageUrl);
  });

    $(document).on('mouseover', '.HorizontalList__Item > a.Heading', function(){
     var imageLink = $(this).parent().find('.MegaMenu__Inner .MegaMenu__Item:first-child .Linklist .Linklist__Item:first-child').attr('menu_image');
    console.log(imageLink)
    $(this).parent().find('.MegaMenu__Item.vk--image-wrapper .vk--menu-image').attr('src', imageLink);
    });

    $('.product__description .product_desc_main:first-child .product_desc-heading').addClass('product_description_toggle');
    $('.product_desc_main .product_desc-heading').on('click', function(){
      $(this).parent().find('.product_desc_body').slideToggle();
      $(this).parent().siblings().find('.product_desc_body').slideUp();
      $(this).toggleClass('product_description_toggle');
      $(this).parent().siblings().find('.product_desc-heading').removeClass('product_description_toggle');
    });
  
});

